module.exports = __webpack_public_path__ + "static/media/lab.326ffb59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/labs/lab.svg
// module id = 108
// module chunks = 0